<template>
  <v-dialog
    :model-value="showDialog"
    class="dialog"
    @update:model-value="closeDialog"
  >
    <v-layout class="br-5">
      <v-app-bar
        dense
        flat
        floating
        fixed
        color="white"
      >
        <v-app-bar-title class="dialog-title">
          Layer library
        </v-app-bar-title>
        <v-text-field
          v-model="searchTerm"
          autofocus
          color="primary"
          base-color="secondary"
          class="dialog-search"
          prepend-inner-icon="mdi-magnify"
          hide-details
          single-line
          clearable
          persistent-clear
          variant="outlined"
          density="compact"
          placeholder="Search layers..."
        />
        <div class="dialog-title__button-wrapper">
          <v-btn
            icon="mdi-close"
            variant="text"
            class="dialog-title__button"
            data-testid="close-layer-dialog"
            style="width: 40px; height: 40px;"
            @click="closeDialog"
          />
        </div>
      </v-app-bar>
      <v-main>
        <v-container class="dialog-container bg-white">
          <v-row class="dialog-row">
            <v-col
              v-for="(layer, index) in filteredLayers"
              :key="layer + index"
              cols="auto"
              class="pl-2"
            >
              <LayerCard
                :layer="layer"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-layout>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex';

import LayerCard from './LayerCard.vue';

export default {
  name: 'LayerDialog',
  components: {
    LayerCard,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      searchTerm: '',
    };
  },
  computed: {
    ...mapState('layers', ['layers']),
    filteredLayers() {
      if (!this.searchTerm) return this.layers;
      return this.layers.filter((layer) => {
        return layer.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.v-overlay__content) {
  height: 100%;
  max-width: 1390px;
  @include main.custom-max-width(1391, 1120px);
  @include main.custom-max-width(1129, 846px);
  @include main.custom-max-width(953, 570px);
  @include main.custom-max-width(615, 305px);
}

.dialog {
  :deep(.v-toolbar__content) {
    justify-content: space-between;
  }

  &-container {
    height: 100%;
    max-width: 100%;
    overflow: scroll;
    margin: 0px;
  }

  :deep(.v-toolbar-title) {
    width: 180px;
    margin-inline-start: 35px;
  }

  &-title {
    font-size: 1.5rem;
    font-weight: 500;
    color: main.$npGray;
    cursor: default;
    flex: none;
    padding: 0 20px 0 10px;

    &__button-wrapper {
      width: 180px;
      display: flex;
      justify-content: end;
      padding-right: 10px;
    }
  }

  &-search {
    max-width: 40%;
  }

  &-row {
    margin-left: 6px;
  }
}
</style>
